import { PersonalShelf, START_OFFSET, VideoProgressMinMax } from '../constants';
import type { WatchHistoryItem } from '../../types/watchHistory';
import type { Playlist, PlaylistItem } from '../../types/playlist';

import { createStore } from './utils';

type WatchHistoryState = {
  watchHistory: WatchHistoryItem[];
  playlistItemsLoaded: boolean;
  continueWatchingPlaylistId: string;
  getItem: (item: PlaylistItem, limitStartProgress?: boolean) => WatchHistoryItem | undefined;
  getStartTime: (item: PlaylistItem) => number;
  getPlaylist: () => Playlist;
  getDictionaryWithEpisodes: () => { [key: string]: number };
  getDictionaryWithSeries: () => { [key: string]: number };
};

export const useWatchHistoryStore = createStore<WatchHistoryState>('WatchHistoryStore', (_, get) => ({
  watchHistory: [],
  playlistItemsLoaded: false,
  continueWatchingPlaylistId: PersonalShelf.ContinueWatching,
  getItem: (item: PlaylistItem, limitStartProgress = true) =>
    get().watchHistory.find(({ mediaid, progress }) => {
      return mediaid === item.mediaid && (!limitStartProgress || progress > VideoProgressMinMax.Min) && progress < VideoProgressMinMax.Max;
    }),
  getStartTime: (item: PlaylistItem) => {
    const watchHistoryItem = get().getItem(item);

    return watchHistoryItem ? Math.max(0, watchHistoryItem.progress * item.duration - START_OFFSET) : 0;
  },
  getPlaylist: () =>
    ({
      feedid: get().continueWatchingPlaylistId || PersonalShelf.ContinueWatching,
      title: 'Continue watching',
      playlist: get()
        .watchHistory.filter(
          ({ playlistItem, seriesId, progress }) =>
            !!playlistItem && ((progress > VideoProgressMinMax.Min && progress < VideoProgressMinMax.Max) || !!seriesId),
        )
        .map(({ playlistItem }) => playlistItem),
    } as Playlist),
  getDictionaryWithEpisodes: () =>
    get().watchHistory.reduce((dict: { [key: string]: number }, item) => {
      const key = item.mediaid;

      dict[key] = item.progress;

      return dict;
    }, {}),
  getDictionaryWithSeries: () =>
    get().watchHistory.reduce((dict: { [key: string]: number }, item) => {
      const key = item.seriesId || item.mediaid;

      dict[key] = item.progress;

      return dict;
    }, {}),
}));
